module.exports = __webpack_public_path__ + "img/4.d6d559a.png";